module.exports = __webpack_public_path__ + "static/media/LoginScreenLogo.87306e60.png";